/**
 * Fogarty cart mutation parity: show the legacy update notice, then reload
 * with openagent=true so the website and concierge show the updated cart.
 * Only successful mutations trigger this; minimizing cancels the reload.
 */
import { on, getState } from "../../core/state.js";

export function initCartRefresh(shadow) {
  if (!shadow) return;
  let timer;
  let toast;

  const cancel = () => {
    clearTimeout(timer);
    toast?.remove();
    toast = null;
  };

  on("ws-cart-mutated", () => {
    cancel();
    if (!getState().chat.isOpen) return;
    const panel = shadow.querySelector("#ws-chat-panel");
    if (!panel) return;
    toast = document.createElement("div");
    toast.className = "ws-fogarty-cart-overlay";
    const notice = document.createElement("div");
    notice.className = "ws-fogarty-cart-toast";
    notice.setAttribute("role", "status");
    const icon = document.createElement("span");
    icon.className = "ws-fogarty-cart-toast-icon";
    icon.setAttribute("aria-hidden", "true");
    icon.innerHTML = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h3l3 13h11l3-9H6M9 20h.01M18 20h.01"/></svg>';
    const body = document.createElement("div");
    const title = document.createElement("strong");
    title.textContent = "Updating your cart...";
    const text = document.createElement("p");
    text.textContent = "The agent will reopen in a moment with your updated cart";
    body.append(title, text);
    notice.append(icon, body);
    toast.append(notice);
    panel.appendChild(toast);
    timer = setTimeout(() => {
      const url = new URL(window.location.href);
      url.searchParams.set("openagent", "true");
      window.location.assign(url.href);
    }, 2200);
  });

  // A new operation must finish successfully before we navigate away.
  on("ws-cart-busy", ({ active }) => { if (active) cancel(); });
  on("ws-toggle", ({ isOpen }) => { if (!isOpen) cancel(); });
  on("ws-messages-cleared", cancel);
}
